"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRICING_TIMEOUT = void 0;
exports.PRICING_TIMEOUT = 60000;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/checkout-sdk/dist/lib-esm/modules/pricingApi/interfaces.js
// module id = 1334
// module chunks = 11